import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/Layouts.vue'
import otherRouter from '@/router/modules/others'
import infoRouter from '@/router/modules/info'
import clientRouter from '@/router/modules/client'
import statusRouter from '@/router/modules/status'
import serviceProviderRouter from '@/router/modules/service-provider'
import rebateRouter from '@/router/modules/rebate'
import businessRouter from '@/router/modules/business'
import payOrder from '@/router/modules/payOrder'
import noLoginLayout from '@/components/noLoginLayout/Index'
import Invite from '@/views/no-login/Invite'
import store from '@/stores'
// import store from '@/stores'

import { getFirstInfo } from '@/api/distributor-api'

Vue.use(Router)

let routes = []

let noLoginRouter = {
  path: '/no-login',
  component: noLoginLayout,
  children: [
    {
      path: 'invite/:id',
      name: 'noLoginInvite',
      component: Invite,
    },
  ],
}

let rootRouter = {
  path: '/',
  component: layout,
  children: [],
  redirect: '/partner/business/sales-performance-info',
}

let redirectRouter = {
  path: '*',
  redirect: '/error',
}
// 其他功能页面
otherRouter(rootRouter.children)
// 我的信息
infoRouter(rootRouter.children)
// 我的客户
clientRouter(rootRouter.children)
// 统一状态页
statusRouter(rootRouter.children)
// 我的下级渠道商
serviceProviderRouter(rootRouter.children)
// 返佣管理
rebateRouter(rootRouter.children)
// 业务数据
businessRouter(rootRouter.children)
// 代付订单列表
payOrder(rootRouter.children)

const router = new Router({
  mode: 'history',
  routes: routes.concat([noLoginRouter, rootRouter, redirectRouter]),
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.isDistributor) {
    try {
      let {
        result: { distributorResult },
      } = await getFirstInfo()
      if (!distributorResult || distributorResult.status !== 1) {
        return next({
          name: 'status',
          params: { status: 'first-distributor-no-permission' },
          query: { hideSideMenu: 1 },
        })
      }
      if (to.meta.isFirstDistributor) {
        if (
          distributorResult.distributorLevel !== 0 ||
          distributorResult.subFlag === 1 // 受“是否有下级渠道”设置影响
        ) {
          return next({
            name: 'status',
            params: { status: 'second-distributor-no-permission' },
          })
        }
      }
      store.commit('DISTRIBUTOR_INFO', distributorResult)
      store.commit(
        'DISTRIBUTOR_HASSUBRETURN',
        distributorResult && distributorResult.subReturnFlag,
      )
      store.commit('DISTRIBUTOR_LEVEL', distributorResult.distributorLevel)
      store.commit(
        'DISTRIBUTOR_HASSUB',
        distributorResult && distributorResult.subFlag,
      )
      store.commit(
        'DISTRIBUTOR_SUBRETURNMODE',
        distributorResult && distributorResult.subReturnMode,
      )
    } catch (e) {
      console.log(e)
    }
  }
  next()
})

export default router
